'use strict';

angular.module('far.models.notice', [])
    .service('Notice', function ($log, $http) {
        this.getByUser = function (user, offset, limit, callback, type) {
            return $http.get(Routing.generate('api_get_notices', {user: user, offset: offset, limit: limit, type: type ? type : 0}))
                .then(function (response) {
                    if (typeof callback == 'function') {
                        return callback(response);
                    }
                }, function errorCallback(response) {
                    $log.error(response);
                });
        };

        this.delete = function (route, callback) {
            return $http.delete(Routing.generate('api_delete_notice', {notice: route.id}))
                .then(function () {
                    route = null;

                    if (typeof callback == 'function') {
                        callback();
                    }
                }, function errorCallback(response) {
                    $log.error(response);
                });
        };

        this.restore = function (route) {
            return $http.patch(Routing.generate('api_patch_notice', {id: route.id}))
                .then(function () {
                    return route = null;
                }, function errorCallback(response) {
                    $log.error(response);
                });
        };

        this.new = function (data) {
            return new Notice(data);
        };

        function Notice(data) {
            angular.merge(this, data);

            Object.defineProperty(this, 'update', {
                enumerable: false,
                get: function () {
                    return function (data) {
                        angular.merge(this, data);

                        return this;
                    }
                }
            });
        }
    });
